import "core-js/modules/es.object.from-entries"

export function decodeSearchAt<T>(
    search: URLSearchParams,
    key: string,
    decode: (s: string) => T | undefined
): T | undefined {
    const value = search.get(key)

    return value === null ? undefined : decode(value)
}

export function searchStringToObj(search: string) {
    return Object.fromEntries(new URLSearchParams(search).entries())
}
